/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function setNavigationBarTitle(params) {
    var _a;
    if (document) {
        document.title = (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : '';
    }
}

export { setNavigationBarTitle as default };
